import { muskegonConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function MuskegonPage() {
  return <CityPageTemplate config={muskegonConfig} />;
}